(() => {
  const bind = (root) => {
    if (root.dataset.bound) return;
    root.dataset.bound = '1';

    const mediaTrack = root.querySelector('[data-story-media-track]');
    const copyTrack = root.querySelector('[data-story-copy-track]');
    const medias = [...root.querySelectorAll('[data-story-media]')];
    const prev = root.querySelector('[data-story-prev]');
    const next = root.querySelector('[data-story-next]');
    const track = root.querySelector('[data-story-progress-track]');
    const thumb = root.querySelector('[data-story-progress-thumb]');
    const count = medias.length;
    if (!count || !mediaTrack || !copyTrack || !track || !thumb) return;

    let index = 0;
    let dragging = false;
    let progress = 0;

    const thumbPct = () => 100 / count;

    const setDragging = (on) => {
      mediaTrack.classList.toggle('is-dragging', on);
      copyTrack.classList.toggle('is-dragging', on);
    };

    const paintTracks = () => {
      const tx = count > 1 ? `translateX(-${progress * (count - 1) * 100}%)` : 'translateX(0)';
      mediaTrack.style.transform = tx;
      copyTrack.style.transform = tx;
    };

    const paintThumb = () => {
      const pct = thumbPct();
      thumb.style.width = `${pct}%`;
      thumb.style.transform = `translateX(${progress * ((100 - pct) / pct) * 100}%)`;
      thumb.setAttribute('aria-valuenow', String(Math.round(progress * 100)));
    };

    const paintControls = () => {
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index >= count - 1;
    };

    const setIndex = (i, { animate = true } = {}) => {
      index = Math.max(0, Math.min(count - 1, i));
      progress = count > 1 ? index / (count - 1) : 0;

      if (!animate) {
        setDragging(true);
        paintTracks();
        paintThumb();
        paintControls();
        requestAnimationFrame(() => {
          requestAnimationFrame(() => setDragging(false));
        });
        return;
      }

      setDragging(false);
      paintTracks();
      paintThumb();
      paintControls();
    };

    const setFromClientX = (clientX) => {
      const pct = thumbPct();
      const rect = track.getBoundingClientRect();
      const thumbPx = (pct / 100) * rect.width;
      const usable = Math.max(1, rect.width - thumbPx);
      const x = Math.min(usable, Math.max(0, clientX - rect.left - thumbPx / 2));
      progress = x / usable;
      index = count > 1 ? Math.round(progress * (count - 1)) : 0;
      paintTracks();
      paintThumb();
      paintControls();
    };

    prev?.addEventListener('click', () => setIndex(index - 1));
    next?.addEventListener('click', () => setIndex(index + 1));

    const startDrag = (event) => {
      dragging = true;
      setDragging(true);
      track.setPointerCapture(event.pointerId);
      setFromClientX(event.clientX);
      event.preventDefault();
    };

    const moveDrag = (event) => {
      if (!dragging) return;
      setFromClientX(event.clientX);
    };

    const endDrag = (event) => {
      if (!dragging) return;
      dragging = false;
      if (track.hasPointerCapture?.(event.pointerId)) {
        track.releasePointerCapture(event.pointerId);
      }
      setIndex(index);
    };

    track.addEventListener('pointerdown', startDrag);
    track.addEventListener('pointermove', moveDrag);
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    thumb.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        setIndex(index + 1);
        event.preventDefault();
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        setIndex(index - 1);
        event.preventDefault();
      } else if (event.key === 'Home') {
        setIndex(0);
        event.preventDefault();
      } else if (event.key === 'End') {
        setIndex(count - 1);
        event.preventDefault();
      }
    });

    setIndex(0, { animate: false });
  };

  const init = () => {
    document.querySelectorAll('[data-customer-stories]').forEach(bind);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
